// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pcfmoegisvljsrehoabd.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBjZm1vZWdpc3ZsanNyZWhvYWJkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzM3NzA3MDgsImV4cCI6MjA0OTM0NjcwOH0.i1mDxl5scP6lt-h9B5X0jD1aXTFWvsTuMZpG5oR_lfo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});